import React, { useState } from 'react';
import {Table, Button, Badge, Tag} from 'antd';
import { collection, query, orderBy, limit, startAfter, getDocs } from "firebase/firestore";
import { useInfiniteQuery } from '@tanstack/react-query';
import {db, functions} from '../base';
import NavBar from "../components/NavBar";
import {httpsCallable} from "firebase/functions"; // Adjust the path to your Firebase config file

const fetchTransactions = async ({ pageParam = null }) => {

    const transactionsQuery = pageParam ? query(
        collection(db, "tutteTransizioni"),
        orderBy("dateTime", "desc"),
        limit(50),
        startAfter(pageParam)
    ): query(
        collection(db, "tutteTransizioni"),
        orderBy("dateTime", "desc"),
        limit(50)
    )

    const querySnapshot = await getDocs(transactionsQuery);

    const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

    const notificheArray = querySnapshot.docs.map(doc => ({
        key: doc.id, // Use doc.id as a unique key for the table rows
        ...doc.data()
    }));

    return {
        data: notificheArray,
        nextPage: lastVisible || null,
    };
};

const TransactionsTable = () => {
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteQuery({
        queryKey: ['transactions'],
        queryFn: fetchTransactions,
        getNextPageParam:  (lastPage) => lastPage.nextPage,
        }
    );

    const transactionTypesColors={
        'GiftCard Spesa': 'purple',
        'Punti Aggiunti': 'green',
        'Punti Spesi': 'red',
    }

    const columns = [
        {
            title: 'Nome Sede',
            dataIndex: 'nomeSede',
            key: 'nomeSede',
        },
        {
            title: 'Spesa',
            dataIndex: 'spesa',
            key: 'spesa',
            render: (spesa) => {
                return spesa+'€'; // Format the date to a readable string
            }
        },
        {
            title: 'Date and Time',
            dataIndex: 'dateTime',
            key: 'dateTime',
            render: (dateTime) => {
                const date = new Date(dateTime.seconds * 1000);
                return date.toLocaleString(); // Format the date to a readable string
            }
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            render: (item) => <Tag color={transactionTypesColors[item]}>{item}</Tag>
        },
    ];

    async function update(){
        const getAllUsers = httpsCallable(functions, 'updateTransactions');
        getAllUsers()
    }

    const dataSource = data?.pages.flatMap(page => page.data) || [];

    return (
        <>
            <NavBar/>
            <main>
                <Table
                    loading={isLoading}
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false} // Disable default pagination
                    rowKey="key"
                />

                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    {hasNextPage && (
                        <Button onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
                            {isFetchingNextPage ? 'Loading more...' : 'Carica altri'}
                        </Button>
                    )}
                </div>
            </main>
        </>
    );
};

export default TransactionsTable;

